import React, { useState } from "react";
import Header from "../components/Header";
import bg from "../assets/images/bg-notification.png";
import SearchIcon from "../assets/icons/search-md.svg";
import InputIcon from "../components/Input/InputIcon";
import { ScrollShadow } from "@nextui-org/react";
import Container from "../components/Container/Container";

const Notifications = () => {
  const [activeCategory, setActiveCategory] = useState("");

  const NotificationFilter = [
    {
      id: 1,
      name: "Semua Notifikasi",
    },
    {
      id: 2,
      name: "Informasi",
    },
    {
      id: 3,
      name: "Tarik Dana",
    },
    {
      id: 4,
      name: "Penukaran",
    },
  ];

  return (
    <>
      <Header title="Notifikasi" transparent />
      <img src={bg} alt="" className="absolute top-0 -z-50 w-full" />
      <Container>
        <div className="space-y-3 pt-20">
          <div className="px-4">
            <InputIcon
              icon={SearchIcon}
              placeholder="Cari Notifikasi"
              // onChange={(e) => {
              //   setSearch(e.target.value);
              //   debounced(e.target.value, 1000);
              // }}
            />
          </div>
          <ScrollShadow
            orientation="horizontal"
            className="mt-3 flex max-w-full gap-2 px-4 pb-3"
          >
            {NotificationFilter.map((item) => (
              <div
                key={item.id}
                onClick={() => setActiveCategory(item.name)}
                className={`flex cursor-pointer items-center justify-center rounded-2xl border px-3  py-1 ${
                  activeCategory !== item.name
                    ? "border-monochrome-50 bg-monochrome-0 text-monochrome-400"
                    : "border-soft-red-500 bg-soft-red-50 text-soft-red-600"
                } `}
              >
                <p className="whitespace-nowrap">{item.name}</p>
              </div>
            ))}
          </ScrollShadow>
        </div>
      </Container>
    </>
  );
};

export default Notifications;
